<template>
	<div class="account-page">
		<PageHeader
			:data="{
				name: 'Account settings',
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>

		<!-- Account navigation -->
		<ul class="nav nav-tabs mt-3" role="tablist">
			<li class="nav-item" role="presentation">
				<router-link class="nav-link" :class="{ active: $route.name === 'account' }" aria-current="page" to="/account">
					<font-awesome-icon :icon="['fas', 'user']" class="me-1" /> General
				</router-link>
			</li>
			<li class="nav-item" role="presentation">
				<router-link class="nav-link" :class="{ active: $route.name === 'accountInformation' }" aria-current="page" to="/account/information">
					<font-awesome-icon :icon="['fas', 'info-circle']" class="me-1" /> Information
				</router-link>
			</li>
			<li class="nav-item" role="presentation">
				<router-link class="nav-link" :class="{ active: $route.name === 'accountSocial' }" aria-current="page" to="/account/social">
					<font-awesome-icon :icon="['fas', 'clock']" class="me-1" /> Social
				</router-link>
			</li>
			<li class="nav-item" role="presentation">
				<router-link class="nav-link" :class="{ active: $route.name === 'accountNotifications' }" aria-current="page" to="/account/notifications">
					<font-awesome-icon :icon="['fas', 'lock']" class="me-1" /> Notifications
				</router-link>
			</li>
			<li class="nav-item" role="presentation">
				<router-link class="nav-link" :class="{ active: $route.name === 'accountPassword' }" aria-current="page" to="/account/password">
					<font-awesome-icon :icon="['fas', 'lock']" class="me-1" /> Change Password
				</router-link>
			</li>
			<li class="nav-item" role="presentation">
				<router-link class="nav-link" :class="{ active: $route.name === 'accountFilters' }" aria-current="page" to="/account/filters">
					<font-awesome-icon :icon="['fas', 'filter']" class="me-1" /> Filters
				</router-link>
			</li>
		</ul>
		<!-- #Account navigation -->

		<!-- Account pages -->
		<div class="js-tab-content mt-3">
			<router-view></router-view>
		</div>
		<!-- #Account pages -->
	</div>
</template>

<script>
//import restApi from "../api/index.js";
import PageHeader from '@/components/layout/PageHeader'
export default {
	name: 'Account',
	components: { PageHeader },
	data() {
		return {}
	},
}
</script>

<style scoped>
/* Settings-language pass — deep selectors reach the router-view tab children */
.account-page >>> .card {
	border: 1px solid #e6e8ec;
	border-radius: 12px;
	box-shadow: none;
}

.account-page >>> .card-header {
	background: transparent;
	border-bottom: 1px solid #f1f3f5;
	padding-bottom: 10px;
}

/* Tabs — settings style: blue bottom-line, no solid pill */
.account-page >>> .nav-tabs {
	border-bottom: 1px solid #e6e8ec;
}
.account-page >>> .nav-tabs .nav-link {
	border: none;
	background: transparent;
	color: #6b7280;
	font-weight: 600;
	font-size: 13px;
	padding: 8px 14px;
	transition: color 0.15s ease, box-shadow 0.15s ease;
}
.account-page >>> .nav-tabs .nav-link:hover {
	color: #111827;
}
.account-page >>> .nav-tabs .nav-link.active,
.account-page >>> .nav-tabs .nav-link.router-link-exact-active.router-link-active {
	background-color: transparent !important;
	color: var(--bs-primary);
	box-shadow: inset 0 -2px 0 var(--bs-primary);
}

/* Inputs */
.account-page >>> .form-control,
.account-page >>> .form-select {
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	box-shadow: none;
}
.account-page >>> .form-control:focus,
.account-page >>> .form-select:focus {
	border-color: #2b6cff;
	box-shadow: 0 0 0 3px rgba(43, 108, 255, 0.15);
}
.account-page >>> .form-check-input:checked {
	background-color: #111827;
	border-color: #111827;
}

/* Buttons → flat settings language */
.account-page >>> .btn-primary {
	background: transparent;
	color: #111827;
	border: 1px solid #111827;
	border-radius: 8px;
	font-weight: 600;
	box-shadow: none;
}
.account-page >>> .btn-primary:hover {
	background: #f3f5f9;
	color: #111827;
}
.account-page >>> .btn-info,
.account-page >>> .btn-secondary {
	background: transparent;
	color: #6b7280;
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	font-weight: 600;
	box-shadow: none;
}
.account-page >>> .btn-info:hover,
.account-page >>> .btn-secondary:hover {
	background: #f3f5f9;
	color: #111827;
	border-color: #d1d5db;
}
.account-page >>> .btn-danger {
	background: transparent;
	color: #dc3545;
	border: 1px solid #f1c2c7;
	border-radius: 8px;
	font-weight: 600;
	box-shadow: none;
}
.account-page >>> .btn-danger:hover {
	background: #fdecee;
	color: #dc3545;
}

/* Badges → soft pills */
.account-page >>> .badge.bg-success {
	background: #d1e7dd !important;
	color: #0f5132 !important;
	font-weight: 600;
}
</style>
